/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Research_Ask_TitleInputs */

const en_research_ask_title = /** @type {(inputs: Research_Ask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask`)
};

/**
* | output |
* | --- |
* | "Ask" |
*
* @param {Research_Ask_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const research_ask_title = /** @type {((inputs?: Research_Ask_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Research_Ask_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_research_ask_title(inputs)
});